import { SelectField } from "melco-shared-logic";
import { useTranslation } from "react-i18next";
//  import { useTranslation } from "react-i18next";

type DisplayCouponsTypesDropDownProps = {

    callbackFn?: any;
};


export const DisplayCouponsTypesDropDown: React.FC<
    DisplayCouponsTypesDropDownProps
> = ({ callbackFn }) => {
    const { t } = useTranslation();
    const couponTypes = [{
        name: t("coupons.table.type.1"),
        code: 1
    },
    {
        name: t("coupons.table.type.2"),
        code: 2
    }]

    return (
        <>
            <SelectField
                name="type"
                label={t("coupons.table.column.type")}
                options={(couponTypes ?? []).map(
                    (couponType: any) => {
                        return {
                            label: couponType.name!,

                            value: couponType.code!,

                        };
                    }
                )}
                showSearch
                optionFilterProp="label"
                onChange={(value, couponType) => callbackFn(value, couponType)}
            />
        </>
    );
};
